import React, { useEffect } from 'react';
import { Frame } from '../../components/frame/frame';
// import { getStore } from '../../store/actions/api/get-store';
import { getRecipe } from '../../store/actions/api/get-recipe';
import { RecipeDetails } from '../../components/recipe/details';
import { CONTENT_MAX_WIDTH } from '../../util/ui';
// import { getFilters } from '../../store/actions/api/get-filters';
import { useTranslation } from 'next-i18next';
// import { GetServerSideProps, InferGetStaticPropsType } from 'next';
import { useAppDispatch, useAppSelector } from '../../store/use-store';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { getFilters } from '../../store/actions/api/get-filters';
import { getStore } from '../../store/actions/api/get-store';
import { ApiService, AxiosWithApi } from '../../services/api';
import { Recipe } from '../../types/api/entities/recipe';
import { redirectToRootUrlRecipe } from '../../util/redirect-to-root-url';
import { GetServerSideProps } from 'next';

type PageProps = { recipe: Recipe };
export default function RecipePage({ recipe: preloadedRecipe }: PageProps) {
  const router = useRouter();
  const {
    query: { id },
  } = router;

  const { t } = useTranslation();

  const recipeId = id instanceof Array ? id[0] : id;
  const dispatch = useAppDispatch();

  const recipe = useAppSelector((s) => s.ui.currentRecipe || preloadedRecipe);
  useEffect(() => {
    dispatch(getFilters());
    dispatch(getStore());
    if (recipeId) {
      dispatch(getRecipe(recipeId));
    }
  }, [recipeId, id, router.query.id, dispatch]);

  return (
    <Frame>
      <div className="content-wrapper">
        <div className="content">
          {recipe ? <RecipeDetails recipe={recipe} /> : t('RecipeDoesNotExist')}
        </div>
      </div>
      <style jsx>{`
        @media screen, print {
          .content-wrapper {
            display: block;
            justify-content: center;
          }

          .content {
            width: 100%;
          }
        }

        @media screen {
          .content-wrapper {
            display: flex;
          }

          .content {
            max-width: ${CONTENT_MAX_WIDTH};
          }
        }

        @media print {
          .content {
            max-width: 790px;
            margin-top: 67px;
          }
        }
      `}</style>
    </Frame>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ locale, query, req, res }) => {
  let apiBaseUrl: string;
  locale = locale || '';

  const queryId = query.id;
  const recipeId = queryId instanceof Array ? queryId[0] : queryId;
  const cookie = req.headers.cookie || '';
  const host = req.headers['codomain'];
  if (host) {
    apiBaseUrl = `https://${host}/api`;
  } else {
    apiBaseUrl = '/api';
  }

  const Api = new ApiService(AxiosWithApi({ apiBaseUrl, cookie }));
  let recipe;
  if (recipeId) {
    recipe = await Api.getRecipe(recipeId);
  }
  const store = await Api.getStore();
  if (store.rootUrl) {
    /**
     * If rootUrl is set it means the store has chosen to use another page where they've likely used
     * embedded the Recipe Explorer on a page of theirs which is where rootUrl points to.
     * So, let's redirect to it.
     */
    redirectToRootUrlRecipe(res, store.rootUrl, recipeId);
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      recipe,
    },
  };
};
